import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import {Delete} from '@mui/icons-material'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import {fieldtype} from 'utils/enums/fieldtype'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Title = styled.div`
    border-bottom: 2px solid rgb(74, 74, 74);
    margin: 20px 0;
    padding-bottom: 5px;
    font-size: 20px;
    display: flex;
    align-items: center;

    > button {
        margin-left: auto;
        padding: 10px;
    }
`

const Control = styled(FormControl)`
	margin-bottom: 20px;
	width: 100%;
`

const CREATE_FIELD_VALUE = -1

const Dataset = ({entities, entityId, owner, consumer, start, end, defaultDuration, count, handleDelete, handleChange, index, intl}) => {
    const onChange = (e) => {
        handleChange({
            [e.target.name]: e.target.value
        }, index)
    }

    const getFields = (entity, types, exception, config) => {
        if (entity && types) {
            return entities.find(obj =>
                obj.id === entity).fields.filter(item => {
                    const condition = config ? item.uiConfig.type === config : true
                    return types.find(type => type === item.uiType) && item.id !== exception && condition
                })      
        } else {
            return []
        }
    }

    const ownerFields = getFields(entityId, [fieldtype.linkedfield])
    const consumerFields = getFields(entityId, [fieldtype.linkedfield])
    const startFields = getFields(entityId, [fieldtype.datetime], end, 'datetime')
    const endFields = getFields(entityId, [fieldtype.datetime], start, 'datetime')
    
    return (
        <Wrapper>
            {count > 1 &&
                <Title>
                    {entities.find(item => item.id === entityId).singular}
                    <IconButton onClick={() => handleDelete(index)}>
                        <Delete />
                    </IconButton>
                </Title>
            }
            <Control variant="standard">
                <InputLabel shrink={true}>
                    {intl.formatMessage({id: "main.planning_entity"})}
                </InputLabel>
                <Select
                    disabled={!entityId}
                    value={entityId}
                    onChange={onChange}
                    inputProps={{
                        name: 'entityId'
                    }}
                >
                    {entities.map((item, index) =>
                        <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                    )}
                </Select>
            </Control>
            <Control variant="standard">
                <InputLabel shrink={true}>
                    {intl.formatMessage({id: "main.scheduler_owner"})}
                </InputLabel>
                <Select
                    disabled={!owner}
                    value={owner}
                    onChange={onChange}
                    inputProps={{
                        name: 'owner'
                    }}
                >
                    {ownerFields.map((item, index) =>
                        <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                    )}
                </Select>
            </Control>
            <Control variant="standard">
                <InputLabel shrink={true}>
                    {intl.formatMessage({id: "main.scheduler_consumer"})}
                </InputLabel>
                <Select
                    disabled={!consumer}
                    value={consumer}
                    onChange={onChange}
                    inputProps={{
                        name: 'consumer'
                    }}
                >
                    {consumerFields.map((item, index) =>
                        <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                    )}
                </Select>
            </Control>
            <Control variant="standard">
                <InputLabel>{intl.formatMessage({id: "main.scheduler_start_field"})}</InputLabel>
                <Select
                    value={start}
                    onChange={onChange}
                    inputProps={{
                        name: 'start'
                    }}
                >
                    {startFields.map((item, index) =>
                        <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                    )}
                    <MenuItem value={CREATE_FIELD_VALUE}>
                        {intl.formatMessage({id: "main.planning_create_field"})}
                    </MenuItem>
                </Select>
            </Control>
            <Control variant="standard">
                <InputLabel>{intl.formatMessage({id: "main.scheduler_end_field"})}</InputLabel>
                <Select
                    value={end}
                    onChange={onChange}
                    inputProps={{
                        name: 'end'
                    }}
                >
                    {endFields.map((item, index) =>
                        <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                    )}
                    <MenuItem value={CREATE_FIELD_VALUE}>
                        {intl.formatMessage({id: "main.planning_create_field"})}
                    </MenuItem>
                </Select>
            </Control>
            <TextField variant="standard"
                value={defaultDuration}
                type='number'
                onChange={onChange}
                label={intl.formatMessage({id: "main.planning_default_duration"})}
                sx={{marginBottom: '20px', width: '100%'}}
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{
                    name: 'defaultDuration'
                }}
            />
        </Wrapper>
    )
}

export default injectIntl(Dataset)
